import { useEffect } from 'react';
import { useArtistSwitcher } from '../../accountSelector/useArtistSwitcher';
import { firstOwnAccountId, isDemoAccount } from '../../accountSelector/demoAccounts';

export interface AddSongArtist {
  /** The own artist the song goes to; null while the list loads or the switch runs. */
  accountId: number | null;
  artistName: string;
  /** The list loaded and the workspace has no artist of its own. */
  hasNoArtist: boolean;
}

/**
 * The artist of "Add my song" (design c1 note). With the demo artist active (after the tour), the
 * page first selects the user's own artist: the demo is read-only and gets no write.
 */
export function useAddSongArtist(): AddSongArtist {
  const { accounts, active, activeAccountId, onSelect } = useArtistSwitcher();
  const ownId = firstOwnAccountId(accounts);
  const isDemoActive = isDemoAccount(active);
  const needsSwitch = accounts !== undefined && ownId !== null && (isDemoActive || activeAccountId === null);

  useEffect(() => {
    if (needsSwitch && ownId !== null) {
      onSelect(ownId);
    }
  }, [needsSwitch, onSelect, ownId]);

  const isReady = accounts !== undefined && active !== undefined && !isDemoActive;
  return {
    accountId: isReady ? active.id : null,
    artistName: isReady ? (active.name ?? '') : '',
    hasNoArtist: accounts !== undefined && ownId === null,
  };
}
